import logger from "../../util/logger";
import React from "react";

import { Route, RouteProps, Redirect } from "react-router-dom";

import { RouteComponentProps } from "react-router";

interface PrivateRouteProps {
    // tslint:disable-next-line:no-any
    component: React.ComponentType<RouteComponentProps<any> | {}>;
    isAllowed: boolean;
}

type PrivateProps = PrivateRouteProps & RouteProps;

const PrivateRoute: React.SFC<PrivateProps> = (props: PrivateProps) => {
    const { component: Component, isAllowed, ...rest } = props;
    return (
        <Route
            {...rest}
            render={(renderProps) => {
                if (isAllowed) {
                    // tslint:disable-next-line:no-any
                    return <Component {...(renderProps as any)} />;
                } else {
                    logger.log(`Location ${renderProps.location}`);
                    return (
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: {
                                    from: renderProps.location,
                                },
                            }}
                        />
                    );
                }
            }}
        />
    );
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.tsx